import { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
    const [showConsent, setShowConsent] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            const timer = setTimeout(() => setShowConsent(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setShowConsent(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'declined');
        setShowConsent(false);
    };

    if (!showConsent) return null;

    return (
        <div style={{ position: 'fixed', bottom: '24px', left: '24px', right: '24px', maxWidth: '420px', backgroundColor: '#ffffff', border: '1px solid #eaeaea', borderRadius: '16px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)', zIndex: 99999, transition: 'all 0.5s ease' }} className="md:left-auto md:right-6 animate-in slide-in-from-bottom-5 fade-in">
            <div style={{ padding: '24px', position: 'relative' }}>
                
                {/* Close Button Absolute */}
                <button
                    onClick={handleDecline}
                    style={{ position: 'absolute', top: '16px', right: '16px', background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px', color: '#999' }}
                    className="hover:text-black transition-colors"
                >
                    <X size={20} />
                </button>

                {/* Content */}
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', paddingRight: '24px' }}>
                    <div style={{ backgroundColor: '#fdf8f0', color: '#c59d3e', padding: '10px', borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Cookie size={24} />
                    </div>
                    <div>
                        <h3 style={{ fontSize: '1.05rem', fontWeight: 800, color: '#111', margin: '0 0 6px 0' }}>Çerez Tercihleri</h3>
                        <p style={{ fontSize: '0.85rem', color: '#666', lineHeight: 1.5, margin: 0 }}>
                            Size daha iyi bir deneyim sunabilmek için sitemizde çerezler kullanıyoruz. Detaylı bilgi için <Link to="/privacy" style={{ color: '#c59d3e', fontWeight: 600, textDecoration: 'none' }} className="hover:underline">Gizlilik Politikamızı</Link> ve <Link to="/terms" style={{ color: '#c59d3e', fontWeight: 600, textDecoration: 'none' }} className="hover:underline">Kullanım Koşullarımızı</Link> inceleyebilirsiniz.
                        </p>
                    </div>
                </div>

                {/* Buttons */}
                <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                    <button 
                        onClick={handleDecline} 
                        style={{ flex: 1, padding: '10px 0', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px', color: '#333', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem' }}
                        className="transition-colors hover:bg-gray-50"
                    >
                        Reddet
                    </button>
                    <button 
                        onClick={handleAccept} 
                        style={{ flex: 1, padding: '10px 0', backgroundColor: '#c59d3e', border: '1px solid #c59d3e', borderRadius: '8px', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem' }}
                        className="transition-opacity hover:opacity-90"
                    >
                        Tümünü Kabul Et
                    </button>
                </div>
                
            </div>
        </div>
    );
}